import { render } from "./KnowledgeType.vue?vue&type=template&id=a80dba58"
import script from "./KnowledgeType.vue?vue&type=script&lang=js"
export * from "./KnowledgeType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__